import React from 'react';

const LiveStream = () => {
  return <div>LiveStream</div>;
};

export default LiveStream;
